import { Calendar } from '@sparefoot/react-core';
import { withProps } from 'recompose';
import classnames from 'classnames';

import './Calendar.scss';

export const enhance = withProps(({ className }) => ({
	className: classnames(className, 'ss-calendar')
}));

export default enhance(Calendar);
